// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessAlert_root__R-R2S"};